import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";
import { Loader2, UserPlus } from "lucide-react";
import { toast } from "sonner";
import { supabase } from "@/integrations/supabase/client";

export const AddAdminForm = () => {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [isLoading, setIsLoading] = useState(false);

  const handleSubmit = async (e: React.FormEvent) => {
    e.preventDefault();
    
    if (password.length < 6) {
      toast.error("Hasło musi mieć minimum 6 znaków");
      return;
    }

    setIsLoading(true);
    try {
      const { data: { session } } = await supabase.auth.getSession();
      
      if (!session?.access_token) {
        toast.error("Musisz być zalogowany jako admin");
        return;
      }

      const response = await supabase.functions.invoke("create-admin", {
        body: { email, password },
      });

      if (response.error) {
        throw new Error(response.error.message || "Błąd tworzenia konta");
      }

      if (response.data?.error) {
        throw new Error(response.data.error);
      }

      toast.success(`Konto admina ${email} utworzone pomyślnie`);
      setEmail("");
      setPassword("");
    } catch (error: any) {
      toast.error(error.message || "Błąd tworzenia konta admina");
    } finally {
      setIsLoading(false);
    }
  };

  return (
    <Card>
      <CardHeader>
        <CardTitle className="flex items-center gap-2">
          <UserPlus className="w-5 h-5" />
          Dodaj nowego admina
        </CardTitle>
        <CardDescription>
          Utwórz konto dla nowego administratora systemu
        </CardDescription>
      </CardHeader>
      <CardContent>
        <form onSubmit={handleSubmit} className="space-y-4">
          <div className="space-y-2">
            <Label htmlFor="new-admin-email">Email nowego admina</Label>
            <Input
              id="new-admin-email"
              type="email"
              value={email}
              onChange={(e) => setEmail(e.target.value)}
              placeholder="nowy-admin@example.com"
              required
            />
          </div>
          <div className="space-y-2">
            <Label htmlFor="new-admin-password">Hasło</Label>
            <Input
              id="new-admin-password"
              type="password"
              value={password}
              onChange={(e) => setPassword(e.target.value)}
              placeholder="Minimum 6 znaków"
              minLength={6}
              required
            />
          </div>
          <Button type="submit" disabled={isLoading} className="w-full">
            {isLoading ? (
              <Loader2 className="w-4 h-4 animate-spin mr-2" />
            ) : (
              <UserPlus className="w-4 h-4 mr-2" />
            )}
            Utwórz konto admina
          </Button>
        </form>
      </CardContent>
    </Card>
  );
};
